
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { DegreeParticipation } from '../../../models/backend-definitions.module';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';

@Injectable()
export class DegreeParticipationEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    DegreeParticipation: DegreeParticipation;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getDegreeParticipation()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getDegreeParticipation(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('degreeParticipation/' + this.routeParams.id).subscribe((res: DegreeParticipation ) => {
                    this.DegreeParticipation = res;
                    this.onDataChanged.next(this.DegreeParticipation);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(DegreeParticipation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('degreeParticipation/', DegreeParticipation).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(DegreeParticipation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('degreeParticipation/', DegreeParticipation).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(DegreeParticipation): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('degreeParticipation/' + DegreeParticipation.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
